import React, { Component } from "react";
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonItem,
  IonList,
  IonButtons,
  IonButton,
  IonSelect,
  IonSelectOption,
  IonInput,
  IonBackButton,
  withIonLifeCycle,
} from "@ionic/react";
import { RouteComponentProps, withRouter } from "react-router";

import _, { filter } from "lodash";

// Images
import iconSearchInactive from "../../assets/Button_Search_1 Default@3x.png";
import iconSearchActive from "../../assets/Button_Search_2 Active@3x.png";
import iconFilterActive from "../../assets/Button_Filter_2 Active@3x.png";
import iconFilterInactive from "../../assets/Button_Filter_1 Default@3x.png";
import iconClearSearch from "../../assets/Button_Cancel@3x.png";
import iconSearch from "../../assets/Button_Search_Small@3x.png";
import iconSearchDark from "../../assets/Button_Search_Small_Dark@3x.png";
import indicatorBookmark from "../../assets/Button_Bookmark_3Small@3x.png";

// CSS
import "../pathways/PathwaysListPage.css";
import "../../Shared.css";
import "../../../App.css";

// Controllers
import {
  IScreenProps,
  IUser,
  IGuideline,
  IGuidelineSummary,
  IClinicalNotice,
  IPathway,
  IPathwayBypassNumber,
  IPathwayWhatGoesWhere,
} from "../../Interfaces";
import AppController from "../../../controllers/AppController";
import DataController from "../../controllers/DataController";
import RemoteDataController from "../../controllers/RemoteDataController";

// Components
import GuidelineCell from "../../components/GuidelineCell";
import ClinicalNoticeCell from "../../components/ClinicalNoticeCell";

type Props = RouteComponentProps<{ id: string; tab: string }> & {
  screenProps: IScreenProps;
  features: string[];
};
type State = {
  showSearch: boolean;
  searchText: string;
  pathwayFilterTypeValue: string;
  pathwayFilterAreaValue: string;
  pathwayFilterCategoryValue: string;
  pathwayFilterHealthBoardValue: string;
  pathwayFilterCouncilAreaValue: string;
};

class PathwaysListPage extends Component<Props, State> {
  private searchTextField: React.RefObject<HTMLIonInputElement>;

  constructor(props: Props) {
    super(props);

    this.searchTextField = React.createRef();

    this.state = {
      showSearch: false,
      searchText: "",
      pathwayFilterTypeValue: "ALL",
      pathwayFilterAreaValue: "ALL",
      pathwayFilterCategoryValue: "ALL",
      pathwayFilterHealthBoardValue: "ALL",
      pathwayFilterCouncilAreaValue: "ALL",
    };
  }

  componentDidMount() {}

  componentDidUpdate(prevProps: Props, prevState: State) {}

  resetFilterAndSearch() {
    this.setState({
      searchText: "",
      pathwayFilterTypeValue: "ALL",
      pathwayFilterAreaValue: "ALL",
      pathwayFilterCategoryValue: "ALL",
      pathwayFilterHealthBoardValue: "ALL",
      pathwayFilterCouncilAreaValue: "ALL",
    });
  }

  toggleSearch() {
    let shouldShow = !this.state.showSearch;

    this.setState({ showSearch: shouldShow });
    if (shouldShow) {
      this.setState({ searchText: "" });

      setTimeout(() => {
        this.searchTextField.current?.setFocus();
      }, 100);
    }
  }

  searchTextChanged(event: any) {
    this.setState({ searchText: event.target.value });
  }

  enterButtonClicked(event: any) {
    if (event.key === "Enter") {
    }
  }

  clearSearch() {
    this.searchTextField.current?.setFocus();
    this.setState({ searchText: "" });
  }

  comparePathwaySelectValues(o1: string, o2: string) {
    return o1 === o2;
  }

  updatePathwayFilter(event: any) {
    if (event.target.id === "pathwayFilterType") {
      let pathwayFilterAreaValue = this.state.pathwayFilterAreaValue;
      if (
        event.detail.value === "ALL" ||
        event.detail.value === "Bypassnumber" ||
        event.detail.value === "Direct Access Hospital Units" ||
        event.detail.value === "Whatgoeswhere" ||
        event.detail.value === "Bookmarked"
      ) {
        pathwayFilterAreaValue = "ALL";
      }
      this.setState({
        pathwayFilterTypeValue: event.detail.value,
        pathwayFilterAreaValue: pathwayFilterAreaValue,
        pathwayFilterCategoryValue: "ALL",
      });
    } else if (event.target.id === "pathwayFilterArea") {
      this.setState({ pathwayFilterAreaValue: event.detail.value, pathwayFilterCategoryValue: "ALL" });
    } else if (event.target.id === "pathwayFilterCategory") {
      this.setState({ pathwayFilterCategoryValue: event.detail.value });
    } else if (event.target.id === "pathwayFilterHealthBoard") {
      this.setState({
        pathwayFilterHealthBoardValue: event.detail.value,
        pathwayFilterCouncilAreaValue: "ALL",
        pathwayFilterCategoryValue: "ALL",
      });
    } else if (event.target.id === "pathwayFilterCouncilArea") {
      this.setState({ pathwayFilterCouncilAreaValue: event.detail.value, pathwayFilterCategoryValue: "ALL" });
    }

    try {
      RemoteDataController.logEvent("pathway_filter_changed", {
        filter_type: event.target.id.replace("pathwayFilter", ""),
        filter_value: event.detail.value,
      });
    } catch (error) {}
  }

  isBookmarked(pathway: IPathway) {
    if (pathway != null) {
      let bookmark = _.find(this.props.screenProps.bookmarks, { pathwayID: pathway.id, type: "pathway" });
      return bookmark != null;
    }

    return false;
  }

  cellClicked(pathway: IPathway | IPathwayBypassNumber | IPathwayWhatGoesWhere) {
    if (this.state.showSearch && this.state.searchText.length > 1) {
      RemoteDataController.logEvent("pathway_search", {
        search_term: this.state.searchText,
      });
    }

    this.props.screenProps.navigateToPathway(
      pathway,
      this.props.match.params.tab,
      this.props.history,
      "List - Pathways"
    );
  }

  render() {
    let pathwayData = this.props.screenProps.pathwayData;

    if (pathwayData == null) {
      return <div></div>;
    }

    let trust = "";
    if (this.props.screenProps.user) {
      trust = this.props.screenProps.user?.trust;
    }
    let searchText = this.state.searchText.toLowerCase();

    let allPathways: (IPathway | IPathwayBypassNumber | IPathwayWhatGoesWhere)[] = [];

    allPathways = allPathways.concat(pathwayData.Pathways, pathwayData.Bypassnumbers, pathwayData.Whatgoeswhere);

    // give each pathway a search score
    let searchRegex = "";
    for (let searchWord of searchText.split(" ")) {
      searchRegex += `(?=.*\\b${searchWord})`;
    }
    let wordBeginsWithRegex = new RegExp(searchRegex);

    for (let pathwayIndex = 0; pathwayIndex < allPathways.length; pathwayIndex++) {
      let pathway = allPathways[pathwayIndex];
      pathway.searchScore = 0;

      if (searchText.length > 1) {
        let pathwayName = DataController.getPathwayName(pathway);

        if (pathwayName.toLowerCase().startsWith(searchText)) {
          pathway.searchScore += 100;
        } else if (wordBeginsWithRegex.test(pathwayName.toLowerCase())) {
          pathway.searchScore += 50;
        } else if (pathwayName.toLowerCase().includes(searchText)) {
          pathway.searchScore += 10;
        }

        if (DataController.isPathway(pathway)) {
          if (pathway.fields["Pathway ID"] && wordBeginsWithRegex.test(pathway.fields["Pathway ID"].toLowerCase())) {
            pathway.searchScore += 50;
          }

          if (pathway.fields.Area && pathway.fields.Area.length > 0) {
            if (pathway.fields.Area.find((area) => area.toLowerCase().includes(searchText))) {
              pathway.searchScore += 30;
            }
          }
        }

        if (pathway.fields["Search Terms"]) {
          let searchTerms = pathway.fields["Search Terms"];
          if (wordBeginsWithRegex.test(searchTerms.join(" ").toLowerCase())) {
            pathway.searchScore += 30;
          }
        }

        // prioritise pathways that match user's region - but only if already matching
        if (pathway.searchScore > 0 && DataController.isPathway(pathway)) {
          if (this.props.screenProps.user?.regions) {
            let userRegions = this.props.screenProps.user.regions;
            let pathwayRegions = pathway.fields["User regions"];
            if (pathwayRegions) {
              for (let region of pathwayRegions) {
                if (userRegions.includes(region)) {
                  pathway.searchScore += 20;
                }
              }
            }
          }
        }
      }
    }

    if (searchText.length > 2 && this.state.showSearch) {
      allPathways = _.orderBy(allPathways, "searchScore", "desc");
    }

    let pathwayCells = [];

    // filter out pathways which don't match filters and create cells for any remaining
    for (let pathwayIndex = 0; pathwayIndex < allPathways.length; pathwayIndex++) {
      let pathway = allPathways[pathwayIndex];

      // remove pathways that don't match search
      if (searchText.length > 1 && pathway.searchScore === 0) {
        continue;
      }

      if (DataController.isPathway(pathway)) {
        let pathwayName = "";
        if (pathway.fields["Pathway name"]) {
          pathwayName = pathway.fields["Pathway name"];
        }

        let pathwaySubtitle = "";
        let pathwayAreas: string[] = [];
        if (pathway.fields.Area) {
          pathwayAreas = pathway.fields.Area;
          pathwaySubtitle = pathway.fields.Area.join(", ");
        }

        let pathwayCategory = "";
        let pathwayCategoryIDs = pathway.fields["Pathway Categories"];
        let pathwayCategories = [];
        let pathwayTypes = [];
        if (pathwayCategoryIDs) {
          for (let pathwayCategoryID of pathwayCategoryIDs) {
            let category = pathwayData.categories.find((category) => category.id === pathwayCategoryID);
            if (category != null) {
              if (category.fields.Category != null) {
                pathwayCategories.push(category.fields.Category);
              }
              if (category.fields["Pathway Type"] != null) {
                pathwayTypes.push(category.fields["Pathway Type"]);
              }
            }
          }
        }

        let pathwayHealthBoards: string[] = [];
        let pathwayCouncilAreas: string[] = [];
        if (pathway.fields["Health Board"]) {
          pathwayHealthBoards = pathway.fields["Health Board"];
        }

        if (this.props.features.includes("pathwayHealthBoards") && pathwayData.CouncilAreas != null) {
          if (pathway.fields["Location details"] != null) {
            let pathwayLocationDetailIDs = pathway.fields["Location details"];
            for (let pathwayLocationDetailID of pathwayLocationDetailIDs) {
              let locationDetail = pathwayData.LocationDetails.find(
                (locationDetail) => locationDetail.id === pathwayLocationDetailID
              );
              if (locationDetail != null && locationDetail.fields["Council Areas"] != null) {
                let pathwayCouncilAreaIDs = locationDetail.fields["Council Areas"];
                for (let pathwayCouncilAreaID of pathwayCouncilAreaIDs) {
                  let councilArea = pathwayData.CouncilAreas.find(
                    (councilArea) => councilArea.id === pathwayCouncilAreaID
                  );
                  if (councilArea != null) {
                    if (
                      councilArea.fields.Name != null &&
                      pathwayCouncilAreas.includes(councilArea.fields.Name) === false
                    ) {
                      pathwayCouncilAreas.push(councilArea.fields.Name);
                    }
                    if (
                      councilArea.fields["Health Board?"] != null &&
                      pathwayHealthBoards.includes(councilArea.fields["Health Board?"]) === false
                    ) {
                      pathwayHealthBoards.push(councilArea.fields["Health Board?"]);
                    }
                  }
                }
              }
            }
          }
        }

        if (pathwayCategories.length > 0) {
          pathwayCategory = pathwayCategories.join(", ");
        }

        // filter out pathways that don't match filters
        if (this.state.pathwayFilterTypeValue === "Bookmarked") {
          if (this.isBookmarked(pathway) === false) {
            continue;
          }
        } else {
          if (this.state.pathwayFilterTypeValue !== "ALL") {
            if (pathwayTypes.includes(this.state.pathwayFilterTypeValue) === false) {
              continue;
            }
          }

          if (this.props.features.includes("pathwayHealthBoards")) {
            if (this.state.pathwayFilterHealthBoardValue !== "ALL") {
              if (pathwayHealthBoards.includes(this.state.pathwayFilterHealthBoardValue) === false) {
                continue;
              }
            }
            if (this.state.pathwayFilterCouncilAreaValue !== "ALL") {
              if (pathwayCouncilAreas.includes(this.state.pathwayFilterCouncilAreaValue) === false) {
                continue;
              }
            }
          } else {
            if (this.state.pathwayFilterAreaValue !== "ALL") {
              if (pathwayAreas.includes(this.state.pathwayFilterAreaValue) === false) {
                continue;
              }
            }
          }

          if (this.state.pathwayFilterCategoryValue !== "ALL") {
            if (pathwayCategories.includes(this.state.pathwayFilterCategoryValue) === false) {
              continue;
            }
          }
        }

        pathwayCells.push(
          <div key={pathway.id} className="pathwayCell" onClick={this.cellClicked.bind(this, pathway)}>
            {this.props.features.includes("pathwayAuthorisedUsersWarning") &&
            DataController.isPathway(pathway) &&
            pathway.fields.AuthorisedUsers ? (
              <div className="pathwayCellAuthorisedUsers">Authorised Users Only</div>
            ) : null}
            <div className="pathwayCellUpperText">
              <div className="pathwayCellTitle">{pathwayName}</div>
              <div className="guidelineIcons">
                {this.isBookmarked(pathway) ? <img className="bookmarkIcon" src={indicatorBookmark} alt="" /> : null}
              </div>
            </div>
            <div className="pathwayCellLowerText">
              <div className="pathwayCellSubtitle">{pathwaySubtitle}</div>
              <div className="pathwayCellCategory">{pathwayCategory}</div>
            </div>
          </div>
        );
      } else if (DataController.isBypassNumber(pathway)) {
        let bypassNumber = pathway;

        let pathwayName = "";
        if (bypassNumber.fields["Pathway category"]) {
          pathwayName = bypassNumber.fields["Pathway category"];
        }

        let pathwaySubtitle = "";
        let pathwayCategory = "Bypass Number";
        if (trust === "SAS") {
          pathwayCategory = "Hospital Radio Codes";
        }

        // filter out pathways that don't match filters
        if (this.state.pathwayFilterTypeValue !== "ALL" && this.state.pathwayFilterTypeValue !== "Bypassnumber") {
          continue;
        }

        if (
          this.state.pathwayFilterAreaValue !== "ALL" ||
          this.state.pathwayFilterHealthBoardValue !== "ALL" ||
          this.state.pathwayFilterCouncilAreaValue !== "ALL" ||
          this.state.pathwayFilterCategoryValue !== "ALL"
        ) {
          continue;
        }

        pathwayCells.push(
          <div key={bypassNumber.id} className="pathwayCell" onClick={this.cellClicked.bind(this, bypassNumber)}>
            <div className="pathwayCellUpperText">
              <div className="pathwayCellTitle">{pathwayName}</div>
            </div>
            <div className="pathwayCellLowerText">
              <div className="pathwayCellSubtitle">{pathwaySubtitle}</div>
              <div className="pathwayCellCategory">{pathwayCategory}</div>
            </div>
          </div>
        );
      } else if (DataController.isWhatGoesWhere(pathway)) {
        let wgw = pathway;

        let pathwayName = "";
        if (wgw.fields["Name"]) {
          pathwayName = wgw.fields["Name"];
        }

        let pathwaySubtitle = "";
        let pathwayCategory = "What Goes Where";

        // filter out pathways that don't match filters
        if (this.state.pathwayFilterTypeValue !== "ALL" && this.state.pathwayFilterTypeValue !== "Whatgoeswhere") {
          continue;
        }

        if (
          this.state.pathwayFilterAreaValue !== "ALL" ||
          this.state.pathwayFilterHealthBoardValue !== "ALL" ||
          this.state.pathwayFilterCouncilAreaValue !== "ALL" ||
          this.state.pathwayFilterCategoryValue !== "ALL"
        ) {
          continue;
        }

        pathwayCells.push(
          <div key={wgw.id} className="pathwayCell" onClick={this.cellClicked.bind(this, wgw)}>
            <div className="pathwayCellUpperText">
              <div className="pathwayCellTitle">{pathwayName}</div>
            </div>
            <div className="pathwayCellLowerText">
              <div className="pathwayCellSubtitle">{pathwaySubtitle}</div>
              <div className="pathwayCellCategory">{pathwayCategory}</div>
            </div>
          </div>
        );
      }
    }

    // build a list of areas, health boards, council areas and categories for each pathway
    let allPathwayDetails: {
      [key: string]: {
        types: string[];
        areas: string[];
        healthboards: string[];
        councilAreas: string[];
        categories: string[];
      };
    } = {};

    for (let pathwayIndex = 0; pathwayIndex < pathwayData.Pathways.length; pathwayIndex++) {
      let pathway = pathwayData.Pathways[pathwayIndex];

      let pathwayTypes: string[] = [];
      let pathwayAreas: string[] = [];
      let pathwayHealthboards: string[] = [];
      let pathwayCouncilAreas: string[] = [];
      let pathwayCategories: string[] = [];

      let pathwayCategoryIDs = pathway.fields["Pathway Categories"];
      if (pathwayCategoryIDs) {
        for (let pathwayCategoryID of pathwayCategoryIDs) {
          let category = pathwayData.categories.find((category) => category.id === pathwayCategoryID);
          if (category != null) {
            if (category.fields.Category != null) {
              pathwayCategories.push(category.fields.Category);
            }
            if (category.fields["Pathway Type"] != null) {
              pathwayTypes.push(category.fields["Pathway Type"]);
            }
          }
        }
      }

      if (this.props.features.includes("pathwayHealthBoards")) {
        if (pathway.fields["Health Board"]) {
          for (let healthboard of pathway.fields["Health Board"]) {
            pathwayHealthboards.push(healthboard);
          }
        }

        if (pathwayData.CouncilAreas != null) {
          if (pathway.fields["Location details"] != null) {
            let pathwayLocationDetailIDs = pathway.fields["Location details"];
            for (let pathwayLocationDetailID of pathwayLocationDetailIDs) {
              let locationDetail = pathwayData.LocationDetails.find(
                (locationDetail) => locationDetail.id === pathwayLocationDetailID
              );
              if (locationDetail != null && locationDetail.fields["Council Areas"] != null) {
                let pathwayCouncilAreaIDs = locationDetail.fields["Council Areas"];
                for (let pathwayCouncilAreaID of pathwayCouncilAreaIDs) {
                  let councilArea = pathwayData.CouncilAreas.find(
                    (councilArea) => councilArea.id === pathwayCouncilAreaID
                  );
                  if (councilArea != null) {
                    if (
                      councilArea.fields.Name != null &&
                      pathwayCouncilAreas.includes(councilArea.fields.Name) === false
                    ) {
                      pathwayCouncilAreas.push(councilArea.fields.Name);
                    }
                    if (
                      councilArea.fields["Health Board?"] != null &&
                      pathwayHealthboards.includes(councilArea.fields["Health Board?"]) === false
                    ) {
                      pathwayHealthboards.push(councilArea.fields["Health Board?"]);
                    }
                  }
                }
              }
            }
          }
        }
      } else {
        if (pathway.fields.Area) {
          pathwayAreas = pathway.fields.Area;
        }
      }

      allPathwayDetails[pathway.id] = {
        types: pathwayTypes,
        areas: pathwayAreas,
        healthboards: pathwayHealthboards,
        councilAreas: pathwayCouncilAreas,
        categories: pathwayCategories,
      };
    }

    // set-up filters
    // get filter type options
    let pathwayFilterTypeOptions = [{ displayName: "Filter Pathway type: All pathways", value: "ALL" }];

    let pathwayFilterTypeCategories: string[] = [];
    for (let pathwayCategory of pathwayData.categories) {
      if (pathwayCategory.fields["Pathway Type"] != null) {
        let category = pathwayCategory.fields["Pathway Type"];
        if (pathwayFilterTypeCategories.includes(category) === false) {
          pathwayFilterTypeCategories.push(category);
        }
      }
    }

    if (trust === "NEAS") {
      // NEAS have asked for custom type filter order
      let priorityOrder: any = { Acute: 1, Urgent: 2, default: Number.MAX_VALUE };

      const prioritized: string[] = [];
      const extra: string[] = [];

      pathwayFilterTypeCategories.forEach((value) => {
        if (priorityOrder[value] !== undefined) prioritized.push(value);
        else extra.push(value);
      });

      prioritized.sort((a, b) => priorityOrder[a] - priorityOrder[b]);
      extra.sort();
      pathwayFilterTypeCategories = prioritized.concat(extra);
    } else {
      pathwayFilterTypeCategories.sort();
    }

    for (let pathwayCategory of pathwayFilterTypeCategories) {
      let displayName = pathwayCategory;
      if (pathwayCategory === "Acute") {
        displayName = "Acute Referral Pathways";
      } else if (pathwayCategory === "Urgent") {
        displayName = "Urgent Care Pathways";
      }
      pathwayFilterTypeOptions.push({ displayName: displayName, value: pathwayCategory });
    }

    if (pathwayData.Bypassnumbers.length > 0) {
      pathwayFilterTypeOptions.push({
        displayName: trust === "SAS" ? "Hospital Radio Codes" : "Emergency Bypass Numbers",
        value: "Bypassnumber",
      });
    }

    if (pathwayData.Whatgoeswhere.length > 0) {
      pathwayFilterTypeOptions.push({ displayName: "What Goes Where?", value: "Whatgoeswhere" });
    }

    pathwayFilterTypeOptions.push({ displayName: "Bookmarked", value: "Bookmarked" });

    let pathwayFilterTypeSelectOptions = [];
    for (let pathwayFilterTypeOption of pathwayFilterTypeOptions) {
      pathwayFilterTypeSelectOptions.push(
        <IonSelectOption key={pathwayFilterTypeOption.value} value={pathwayFilterTypeOption.value}>
          {pathwayFilterTypeOption.displayName}
        </IonSelectOption>
      );
    }

    // get filter area options
    let pathwayFilterAreaOptions = [{ displayName: "Select Area", value: "ALL" }];
    let areasForFilteredPathways: string[] = [];
    for (let pathwayIndex = 0; pathwayIndex < pathwayData.Pathways.length; pathwayIndex++) {
      let pathway = pathwayData.Pathways[pathwayIndex];

      let pathwayDetails = allPathwayDetails[pathway.id];
      if (pathwayDetails != null) {
        areasForFilteredPathways = areasForFilteredPathways.concat(pathwayDetails.areas);
      }
    }

    areasForFilteredPathways = _.uniq(areasForFilteredPathways);
    areasForFilteredPathways.sort();

    for (let area of areasForFilteredPathways) {
      pathwayFilterAreaOptions.push({ displayName: area, value: area });
    }

    let pathwayFilterAreaSelectOptions = [];
    for (let pathwayFilterAreaOption of pathwayFilterAreaOptions) {
      pathwayFilterAreaSelectOptions.push(
        <IonSelectOption key={pathwayFilterAreaOption.value} value={pathwayFilterAreaOption.value}>
          {pathwayFilterAreaOption.displayName}
        </IonSelectOption>
      );
    }

    // get filter healthboard options
    let pathwayFilterHealthBoardOptions = [{ displayName: "Select Health Board", value: "ALL" }];
    let healthboardsForFilteredPathways: string[] = [];

    for (let pathwayIndex = 0; pathwayIndex < pathwayData.Pathways.length; pathwayIndex++) {
      let pathway = pathwayData.Pathways[pathwayIndex];

      let pathwayDetails = allPathwayDetails[pathway.id];
      if (pathwayDetails != null) {
        if (this.state.pathwayFilterTypeValue !== "ALL") {
          if (pathwayDetails.types.includes(this.state.pathwayFilterTypeValue) === false) {
            continue;
          }
        }

        healthboardsForFilteredPathways = healthboardsForFilteredPathways.concat(pathwayDetails.healthboards);
      }
    }

    healthboardsForFilteredPathways = _.uniq(healthboardsForFilteredPathways);
    healthboardsForFilteredPathways.sort();

    for (let healthboard of healthboardsForFilteredPathways) {
      pathwayFilterHealthBoardOptions.push({ displayName: healthboard, value: healthboard });
    }

    let pathwayFilterHealthBoardSelectOptions = [];
    for (let pathwayFilterHealthBoardOption of pathwayFilterHealthBoardOptions) {
      pathwayFilterHealthBoardSelectOptions.push(
        <IonSelectOption key={pathwayFilterHealthBoardOption.value} value={pathwayFilterHealthBoardOption.value}>
          {pathwayFilterHealthBoardOption.displayName}
        </IonSelectOption>
      );
    }

    // get council areas options
    let pathwayFilterCouncilAreaOptions = [{ displayName: "Select Council Area", value: "ALL" }];
    let councilAreasForFilteredPathways: string[] = [];

    for (let pathwayIndex = 0; pathwayIndex < pathwayData.Pathways.length; pathwayIndex++) {
      let pathway = pathwayData.Pathways[pathwayIndex];

      let pathwayDetails = allPathwayDetails[pathway.id];
      if (pathwayDetails != null) {
        if (this.state.pathwayFilterTypeValue !== "ALL") {
          if (pathwayDetails.types.includes(this.state.pathwayFilterTypeValue) === false) {
            continue;
          }
        }

        if (this.state.pathwayFilterHealthBoardValue !== "ALL") {
          if (pathwayDetails.healthboards.includes(this.state.pathwayFilterHealthBoardValue) === false) {
            continue;
          }
        }

        councilAreasForFilteredPathways = councilAreasForFilteredPathways.concat(pathwayDetails.councilAreas);
      }
    }

    councilAreasForFilteredPathways = _.uniq(councilAreasForFilteredPathways);
    councilAreasForFilteredPathways.sort();

    for (let councilArea of councilAreasForFilteredPathways) {
      pathwayFilterCouncilAreaOptions.push({ displayName: councilArea, value: councilArea });
    }

    let pathwayFilterCouncilAreaSelectOptions = [];
    for (let pathwayFilterCouncilAreaOption of pathwayFilterCouncilAreaOptions) {
      pathwayFilterCouncilAreaSelectOptions.push(
        <IonSelectOption key={pathwayFilterCouncilAreaOption.value} value={pathwayFilterCouncilAreaOption.value}>
          {pathwayFilterCouncilAreaOption.displayName}
        </IonSelectOption>
      );
    }

    // get filter category options
    let pathwayFilterCategoryOptions = [{ displayName: "Select Category", value: "ALL" }];
    let categoriesForFilteredPathways: string[] = [];
    for (let pathwayIndex = 0; pathwayIndex < pathwayData.Pathways.length; pathwayIndex++) {
      let pathway = pathwayData.Pathways[pathwayIndex];

      let pathwayDetails = allPathwayDetails[pathway.id];
      if (pathwayDetails != null) {
        if (this.state.pathwayFilterTypeValue !== "ALL") {
          if (pathwayDetails.types.includes(this.state.pathwayFilterTypeValue) === false) {
            continue;
          }
        }

        if (this.state.pathwayFilterAreaValue !== "ALL") {
          if (pathwayDetails.areas.includes(this.state.pathwayFilterAreaValue) === false) {
            continue;
          }
        }

        if (this.state.pathwayFilterHealthBoardValue !== "ALL") {
          if (pathwayDetails.healthboards.includes(this.state.pathwayFilterHealthBoardValue) === false) {
            continue;
          }
        }

        if (this.state.pathwayFilterCouncilAreaValue !== "ALL") {
          if (pathwayDetails.councilAreas.includes(this.state.pathwayFilterCouncilAreaValue) === false) {
            continue;
          }
        }

        categoriesForFilteredPathways = categoriesForFilteredPathways.concat(pathwayDetails.categories);
      }
    }

    categoriesForFilteredPathways = _.uniq(categoriesForFilteredPathways);
    categoriesForFilteredPathways.sort();

    for (let category of categoriesForFilteredPathways) {
      pathwayFilterCategoryOptions.push({ displayName: category, value: category });
    }

    let pathwayFilterCategorySelectOptions = [];
    for (let pathwayFilterCategoryOption of pathwayFilterCategoryOptions) {
      pathwayFilterCategorySelectOptions.push(
        <IonSelectOption key={pathwayFilterCategoryOption.value} value={pathwayFilterCategoryOption.value}>
          {pathwayFilterCategoryOption.displayName}
        </IonSelectOption>
      );
    }

    // enable filters
    let pathwayFilterAreaEnabled = true;
    let pathwayFilterCategoryEnabled = true;
    let pathwayFilterHealthBoardEnabled = true;
    let pathwayFilterCouncilAreaEnabled = true;

    if (
      this.state.pathwayFilterTypeValue === "Bypassnumber" ||
      this.state.pathwayFilterTypeValue === "Direct Access Hospital Units" ||
      this.state.pathwayFilterTypeValue === "Whatgoeswhere" ||
      this.state.pathwayFilterTypeValue === "Bookmarked"
    ) {
      pathwayFilterAreaEnabled = false;
      pathwayFilterCategoryEnabled = false;
      pathwayFilterHealthBoardEnabled = false;
      pathwayFilterCouncilAreaEnabled = false;
    }

    let shouldShowBackButton = false;

    return (
      <IonPage>
        <IonHeader>
          <IonToolbar mode="ios" className="navBar">
            <IonButtons slot="start" className="headerButtonText" color="#FFFFFF">
              {shouldShowBackButton ? (
                <IonBackButton defaultHref={`/${this.props.match.params.tab}`} class="headerButtonText" />
              ) : null}
            </IonButtons>
            <IonButtons slot="end">
              <IonButton onClick={() => this.toggleSearch()}>
                <img className="icon-44" src={this.state.showSearch ? iconSearchActive : iconSearchInactive} />
              </IonButton>
            </IonButtons>
            {this.state.showSearch ? (
              <div className="guidelineListSearchHeader listPageSearchHeader">
                <div className={`guidelinesSearchInputContainer`}>
                  <img alt="" src={this.props.screenProps.darkMode ? iconSearchDark : iconSearch} className="icon-44" />
                  <IonInput
                    value={this.state.searchText}
                    className="searchInputField"
                    placeholder="Search Location Pathways"
                    onIonInput={(event) => this.searchTextChanged(event)}
                    clearOnEdit={false}
                    ref={this.searchTextField}
                    onKeyDown={(event) => this.enterButtonClicked(event)}
                  />
                  {this.state.searchText ? (
                    <IonButton className="searchClearButton" mode="ios" onClick={this.clearSearch.bind(this)}>
                      <img alt="" src={iconClearSearch} className="icon-44" />
                    </IonButton>
                  ) : null}
                </div>
              </div>
            ) : (
              <IonTitle>Pathways</IonTitle>
            )}
          </IonToolbar>
        </IonHeader>
        <IonContent fullscreen>
          <div className="globalContentMargin">
            <div className="pathwayFilterContainer">
              <div className="pathwayFilterSelectContainer">
                <IonSelect
                  className="pathwayFilterSelect"
                  interface="popover"
                  interfaceOptions={{ cssClass: "pathway-filter-popover" }}
                  mode="ios"
                  onIonChange={(event) => this.updatePathwayFilter(event)}
                  id="pathwayFilterType"
                  placeholder="Select"
                  compareWith={this.comparePathwaySelectValues}
                  value={this.state.pathwayFilterTypeValue}
                >
                  {pathwayFilterTypeSelectOptions}
                </IonSelect>

                {this.props.features.includes("pathwayHealthBoards") ? (
                  <>
                    <IonSelect
                      className="pathwayFilterSelect"
                      interface="popover"
                      disabled={!pathwayFilterHealthBoardEnabled}
                      interfaceOptions={{ cssClass: "pathway-filter-popover" }}
                      mode="ios"
                      onIonChange={(event) => this.updatePathwayFilter(event)}
                      id="pathwayFilterHealthBoard"
                      placeholder="Select Health Board"
                      compareWith={this.comparePathwaySelectValues}
                      value={this.state.pathwayFilterHealthBoardValue}
                    >
                      {pathwayFilterHealthBoardSelectOptions}
                    </IonSelect>
                    <IonSelect
                      className="pathwayFilterSelect"
                      interface="popover"
                      disabled={!pathwayFilterCouncilAreaEnabled}
                      interfaceOptions={{ cssClass: "pathway-filter-popover" }}
                      mode="ios"
                      onIonChange={(event) => this.updatePathwayFilter(event)}
                      id="pathwayFilterCouncilArea"
                      placeholder="Select Council Area"
                      compareWith={this.comparePathwaySelectValues}
                      value={this.state.pathwayFilterCouncilAreaValue}
                    >
                      {pathwayFilterCouncilAreaSelectOptions}
                    </IonSelect>
                  </>
                ) : (
                  <IonSelect
                    className="pathwayFilterSelect"
                    interface="popover"
                    disabled={!pathwayFilterAreaEnabled}
                    interfaceOptions={{ cssClass: "pathway-filter-popover" }}
                    mode="ios"
                    onIonChange={(event) => this.updatePathwayFilter(event)}
                    id="pathwayFilterArea"
                    placeholder="Select Area"
                    compareWith={this.comparePathwaySelectValues}
                    value={this.state.pathwayFilterAreaValue}
                  >
                    {pathwayFilterAreaSelectOptions}
                  </IonSelect>
                )}

                <IonSelect
                  className="pathwayFilterSelect"
                  interface="popover"
                  disabled={!pathwayFilterCategoryEnabled}
                  interfaceOptions={{ cssClass: "pathway-filter-popover" }}
                  mode="ios"
                  onIonChange={(event) => this.updatePathwayFilter(event)}
                  id="pathwayFilterCategory"
                  placeholder="Select"
                  compareWith={this.comparePathwaySelectValues}
                  value={this.state.pathwayFilterCategoryValue}
                >
                  {pathwayFilterCategorySelectOptions}
                </IonSelect>
              </div>

              <div className="pathwayFilterInfoContainer">
                <div className="pathwayFilterText">Results: {pathwayCells.length}</div>
                <IonButton
                  mode="ios"
                  className="clearButton pathwayResetFilterButton"
                  onClick={this.resetFilterAndSearch.bind(this)}
                >
                  Reset
                </IonButton>
              </div>
            </div>

            {pathwayCells}

            {pathwayCells.length === 0 ? (
              <div className="pathwayEmptyResults">
                There are no matching pathways. Try changing your filters or search to see more results.
              </div>
            ) : null}
          </div>
        </IonContent>
      </IonPage>
    );
  }
}

export default withRouter(withIonLifeCycle(PathwaysListPage));
